/* ------------------------------------------------------------
   src/pages/Dashboard.jsx
   – no extra CSS imports (only dashboard.css if you want)
------------------------------------------------------------- */
import React, { useEffect, useState } from "react";
import $ from "jquery";          // only used to start slick()
import "slick-carousel";         // slick-js was already in <script> tags
import CustomLoader from "../components/CustomLoader";

export default function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  /* run jQuery slick once React has painted */
  useEffect(() => {
    const $sliders = $(".work-experiance-slider");
    if ($sliders.length && $sliders.slick) {
      $sliders.slick({
        dots: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  }, []);

  /* helper so we can load images that sit in /public/assets/... */
  const asset = (p) => process.env.PUBLIC_URL + p;

  return (
    <div id="page-content">
      {/* Custom Loader */}
      {isLoading && <CustomLoader />}
      {/* =============  HEADER  ============= */}
      <header className="header-area">
        <nav className="navbar">
          <div className="container">
            <div className="menu-container">
              {/* ---------- logo ---------- */}
              <div className="logo">
                <a className="navbar-brand me-0" href="/">
                  {/* SVG kept 100 % identical – React will accept it */}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      className="logo-icon"
                      d="M0 1.5C0 1.10218 ... 13.5 22.5V15Z"
                    />
                  </svg>
                  <span>
                    user<span className="primary">name</span>
                  </span>
                </a>
              </div>

              {/* ---------- nav links ---------- */}
              <div className="navbar-main d-flex flex-grow-1">
                <ul className="navbar-info mx-auto">
                  <li className="nav-item">
                    <a className="nav-link active" href="/">
                      {/* home icon */}
                      <svg className="nav-icon" viewBox="0 0 15 15" fill="none">
                        <path
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.475 4.924...10.1665"
                        />
                      </svg>
                      <span>Home</span>
                    </a>
                  </li>

                  <li className="nav-item">
                    <a className="nav-link" href="/customerdetail">
                      {/* user icon */}
                      <svg className="nav-icon" viewBox="0 0 18 18" fill="none">
                        <path
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 9.833...15.7085"
                        />
                      </svg>
                      My Detail
                    </a>
                  </li>

                  <li className="nav-item">
                    <a className="nav-link" href="/services">
                      {/* stacked-layers icon */}
                      <svg className="nav-icon" viewBox="0 0 16 16" fill="none">
                        <path
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M7.999 1.333...11.333"
                        />
                      </svg>
                      Services
                    </a>
                  </li>

                  <li className="nav-item">
                    <a className="nav-link" href="/contact">
                      {/* mail icon */}
                      <svg className="nav-icon" viewBox="0 0 18 17" fill="none">
                        <path
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5.666 5.5H12.334"
                        />
                        <path
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5.667 8.833...10.667"
                        />
                        <path
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M14 1.333...15.708"
                        />
                      </svg>
                      Contact
                    </a>
                  </li>
                </ul>

                {/* theme toggle + logout */}
                <div className="header-right-info d-flex align-items-center">
                  <button className="theme-control-btn">
                    <i className="fas fa-sun" /> {/* placeholder */}
                  </button>
                  <a href="/logout" className="lets-talk-btn">
                    Logout&nbsp;<i className="fas fa-sign-out-alt" />
                  </a>
                </div>
              </div>

              {/* hamburger – you can hook your own click-handler */}
              <button className="mobile-menu-control-bar d-xl-none">
                <i className="fas fa-bars" />
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* =============  MAIN  ============= */}
      <main>
        <section className="home-area">
          <div className="container">
            <div className="row g-4">
              {/* ----------------------------------------------------------------
                   1️⃣  PROFILE CARD (left column)
              ---------------------------------------------------------------- */}
              <div className="col-xl-4">
                <div className="card profile-card">
                  <div className="card-body">
                    <div className="image text-center">
                      <img
                        src={asset("/assets/img/images/profile.png")}
                        alt="profile"
                      />
                    </div>

                    <h3 className="card-title text-center">
                      <img
                        src={asset("/img/img-icon/logo_xinchuan.png")}
                        alt="Xin Chuan"
                        style={{ height: 60, maxWidth: "100%" }}
                      />
                    </h3>

                    <p className="text-center">
                      Elevating{" "}
                      <span>Interiors, Exteriors &amp; Landscapes</span>{" "}
                      <span>20++ years of Experiences</span> – more than{" "}
                      <span>100 Completed</span> projects in Malaysia.
                    </p>

                    <div className="common-button-groups text-center">
                      <a
                        className="btn btn-call me-2"
                        href="https://wa.me/60123456789?text=Hello!"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-whatsapp me-1" />
                        Call Us
                      </a>
                      <button
                        className="btn btn-copy"
                        data-clipboard-text="example@example.com"
                      >
                        <i className="far fa-copy me-1" />
                        Copy Email
                      </button>
                    </div>

                    <ul className="social-media-icon list-unstyled d-flex justify-content-center gap-3 mt-3">
                      {["facebook", "instagram", "twitter", "youtube", "whatsapp"].map(
                        (net) => (
                          <li key={net}>
                            <a href="#">
                              <i className={`fab fa-${net}`} />
                            </a>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              {/* ----------------------------------------------------------------
                   2️⃣  MIDDLE COLUMN (timeline + request icons)
              ---------------------------------------------------------------- */}
              <div className="col-xl-4">
                {/* Payment timeline */}
                <div className="card mb-4">
                  <div className="card-body work-experiance-card">
                    <h3 className="card-title">Payment Timeline</h3>

                    {/* first slider */}
                    <ul className="work-experiance-slider list-unstyled">
                      {[
                        ["2025-05", "Window", "pay before 20 May RM 4 500"],
                        ["2025-03", "Paint", "payment RM 10 000"],
                        ["2025-02", "Moset", "payment RM 5 000"],
                        ["2025-01", "Customization Furt", "payment RM 25 000"]
                      ].map(([d, t, s]) => (
                        <li key={d}>
                          <div className="date">
                            <p>{d}</p>
                          </div>
                          <div className="info">
                            <div className="icon">
                              <img
                                src="https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/sketchup.svg"
                                alt=""
                                width="32"
                                height="32"
                                style={{ filter: "invert(1) brightness(2)" }}
                              />
                            </div>
                            <div className="text">
                              <h4 className="title">{t}</h4>
                              <h6 className="subtitle">{s}</h6>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>

                    {/* second slider */}
                    <ul className="work-experiance-slider list-unstyled">
                      {[
                        ["2025-06", "Material 50 %", "payment RM 50 500"],
                        ["2025-07", "Interior Design 30 %", "payment RM 20 500"],
                        ["2025-08", "Gate", "payment RM 3 500"],
                        ["2025-09", "Air-con", "payment RM 2 500"]
                      ].map(([d, t, s]) => (
                        <li key={d}>
                          <div className="date">
                            <p>{d}</p>
                          </div>
                          <div className="info">
                            <div className="icon">
                              <img
                                src="https://cdn.jsdelivr.net/npm/simple-icons@v10/icons/sketchup.svg"
                                alt=""
                                width="32"
                                height="32"
                                style={{ filter: "invert(1) brightness(2)" }}
                              />
                            </div>
                            <div className="text">
                              <h4 className="title">{t}</h4>
                              <h6 className="subtitle">{s}</h6>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Requests */}
                <div className="card expertise-card">
                  <div className="card-body">
                    <h3 className="card-title">Request</h3>
                    <div className="row g-3 mt-3">
                      {[
                        ["Design", 1],
                        ["Base", 2],
                        ["Interior", 3],
                        ["Framer", 4],
                        ["Drawing", 5],
                        ["Measurement", 6]
                      ].map(([title, num]) => (
                        <div key={title} className="col-6 col-md-4">
                          <div className="expertise-item text-center">
                            <div className="image text-center">
                              <img
                                src={asset(
                                  `/assets/img/png/house, construction, project, docs,${num}.png`
                                )}
                                alt={title}
                              />
                            </div>
                            <h4 className="title mt-1">{title}</h4>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* ----------------------------------------------------------------
                   3️⃣  RIGHT COLUMN (projects + modals)
              ---------------------------------------------------------------- */}
              <div className="col-xl-4">
                <div className="card card-projects">
                  <div className="card-body">
                    <h3 className="card-title">
                      On Going Project{" "}
                      <a className="link-btn" href="/portfolio">
                        All Projects&nbsp;
                        <i className="fas fa-arrow-right" />
                      </a>
                    </h3>

                    <div className="projects-main mt-3">
                      <div className="row g-3">
                        {/* project-1 */}
                        <div className="col-md-6">
                          <ProjectCard
                            id={1}
                            img={asset("/assets/img/projects/project-1.png")}
                            tag="#5031"
                            badge="Product Design"
                          />
                        </div>
                        {/* project-2 */}
                        <div className="col-md-6">
                          <ProjectCard
                            id={2}
                            img={asset("/assets/img/projects/project-2.png")}
                            tag="1221×844"
                            badge="Project 002"
                          />
                        </div>
                      </div>
                    </div>

                    {/* two bootstrap modals, same HTML you had */}
                    <ProjectModal id={1} title="Project 5031 : 12 Jalan Kulai Renovation" />
                    <ProjectModal id={2} title="Project 002" />
                  </div>
                </div>
              </div>
            </div>

            {/* ----------------------------------------------------------------
                 SERVICES STRIP
            ---------------------------------------------------------------- */}
            <div className="services-area mt-5">
              <div className="card services-card">
                <div className="card-body">
                  <h3 className="card-title">
                    Service Offer by XinChuan{" "}
                    <a className="link-btn" href="/services">
                      See All Services&nbsp;
                      <i className="fas fa-arrow-right" />
                    </a>
                  </h3>

                  <div className="row g-3 mt-3">
                    {[
                      ["Architecture", "icon-planing.png"],
                      ["Interiors", "icon-architecture.png"],
                      ["Planning", "icon-interiors.png"],
                      ["Basing", "resized_icon.png"]
                    ].map(([title, img]) => (
                      <div key={title} className="col-6 col-md-3 text-center">
                        <div className="services-item">
                          <div
                            className="image d-flex align-items-center justify-content-center overflow-hidden"
                            style={{ height: 100 }}
                          >
                            <img
                              src={asset(`/img/img-icon/${img}`)}
                              alt={title}
                              style={{ maxHeight: "100%", objectFit: "contain" }}
                            />
                          </div>
                          <h4 className="title mt-2">{title}</h4>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* =============  FOOTER  ============= */}
      <footer className="footer-area py-4">
        <div className="container">
          <p className="text-center mb-0">© XINCHUAN 2025</p>
        </div>

        {/* vertical background lines */}
        <div className="page-lines">
          <div className="container-fluid h-100 px-0">
            <div className="row gx-0 h-100">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="col">
                  <div className="line" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/* SMALL RE-USABLE COMPONENTS                                         */
/* ------------------------------------------------------------------ */

function ProjectCard({ id, img, tag, badge }) {
  return (
    <div className="card bg-dark text-white position-relative">
      <img src={img} className="card-img-top" alt={`project-${id}`} />
      <div className="card-body">
        <h5 className="card-title">{tag}</h5>
        <span className="badge bg-primary">{badge}</span>
      </div>
      <button
        className="btn btn-sm btn-light position-absolute top-0 end-0 m-2 rounded-circle"
        data-bs-toggle="modal"
        data-bs-target={`#projectModal${id}`}
      >
        <i className="fas fa-plus" />
      </button>
    </div>
  );
}

function ProjectModal({ id, title }) {
  return (
    <div
      className="modal fade"
      id={`projectModal${id}`}
      tabIndex="-1"
      aria-labelledby={`projectModal${id}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-dark text-white">
          <div className="modal-header border-0">
            <h5 className="modal-title" id={`projectModal${id}Label`}>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
            />
          </div>

          <div className="modal-body">
            {/* put your real accordion / info here or reuse the long HTML */}
            <p className="text-muted">
              You can paste the full accordion HTML inside this area exactly as
              in your static file – Bootstrap’s JS from <code>index.html</code>{" "}
              will keep working in React.
            </p>
          </div>

          <div className="modal-footer border-0">
            <button
              type="button"
              className="btn btn-outline-light"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
